import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GoogleSearchConsoleService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/google/search-console`;

  constructor(private http: HttpClient) { }

  public canIndex(customerId: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/${customerId}/can-index`);
  }
}
